import { useDefaultMediaQueries } from "@kolibrisoftware/hooks-util";
import { PageLoadingStatus } from "enums/page-loading-status";
import MobileNavigation from "layouts/mobile-navigation-layout/mobile-navigation";
import { useCallback, useEffect, useLayoutEffect, useRef } from "react";
import { Outlet, useParams } from "react-router-dom";
import {
  actions as dossierActions,
  thunks as dossierThunks,
} from "store/dossier";
import { useDispatch, useSelector } from "store/helpers";
import { thunks as mainThunks } from "store/main";
import {
  actions as objectPreviewActions,
  thunks as objectPreviewThunks,
} from "store/object-preview";

export const DossierModuleWrapper = () => {
  const { isScreenXS, isScreenS } = useDefaultMediaQueries();
  const { dossierId } = useParams();
  const initialized = useRef(false);
  const dispatch = useDispatch();
  const { loadingStatus, userLinkType } = useSelector(state => state.dossier);
  const companyData = useSelector(state => state.main.companyData);
  const culture = useSelector(state => state.main.culture);

  const initial = useCallback(async () => {
    try {
      dispatch(dossierActions.clearState());
      if (!companyData) {
        await dispatch(mainThunks.getCompanyData());
      }

      await dispatch(
        dossierThunks.loadAssignment({
          assignmentId: dossierId || "",
          userLinkType,
        })
      );

      dispatch(
        objectPreviewActions.setLoadingStatus(PageLoadingStatus.Loading)
      );

      await dispatch(objectPreviewThunks.loadAssignmentPreview());
    } catch (error) {
      throw error;
    } finally {
      dispatch(
        objectPreviewActions.setLoadingStatus(PageLoadingStatus.Success)
      );
    }
  }, [dossierId, dispatch, companyData, userLinkType]);

  useLayoutEffect(() => {
    if (!initialized.current) {
      initial();
      initialized.current = true;
    }
  }, [initial]);

  useEffect(() => {
    if (initialized.current && loadingStatus === PageLoadingStatus.Success) {
      dispatch(dossierThunks.loadChecklistItems({ culture: culture }));
    }
  }, [culture, dispatch, loadingStatus]);

  return (
    <>
      {loadingStatus === PageLoadingStatus.Success && <Outlet />}
      {(isScreenXS || isScreenS) && <MobileNavigation />}
    </>
  );
};
